var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white",
      "height": "-webkit-fill-available"
    },
    attrs: {
      "id": "image-layout"
    }
  }, [_c('viewer-container', {
    attrs: {
      "activeData": _vm.activeData,
      "focus": _vm.focus
    },
    on: {
      "pointedSelection": function($event) {
        _vm.executeOnPointedSelection()
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4db53e4e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub-views/Image.vue
// module id = 1654
// module chunks = 1